
import TEditor from "@/components/editor/TEditor.vue";
import { ElMessage } from "element-plus";
import { getEnum } from "@/api/index";
import { useRouter, useRoute } from "vue-router";
import { putProduct, getProductInfo ,getAllUsage } from "@/api/backstage";
import type { ElForm } from "element-plus";
import Uploadimg from "@/components/uploadimg/Index.vue";
import Uploadfile from "@/components/uploadfile/Index.vue";
import { useStore } from "vuex";
type FormInstance = InstanceType<typeof ElForm>;

import {
  defineComponent,
  reactive,
  computed,
  ref,
  unref,
  toRefs,
  watch,
  onMounted,
} from "vue";
export default defineComponent({
  name: "新增用户",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  components: {
    Uploadimg,
  },

  setup(opt, contex) {
    const store = useStore();
    let isEdit = false;
    let show = opt.open;
    const router = useRouter();
    const route = useRoute();
    const dataMap: any = reactive({
      ruleFormRef: ref<FormInstance>(),
      sex: {},
      dragIndex:'',
      dropIndex:'',
      temp:'',
      productType: {},
      usageScene:'',
      status: {},
      index:'',
      ruleForm: {
        title: "",
        productType: "",
        coverId: "",
        description: "",
        trialCoverId:'',
        appFileName: "",
        pcFileName: "",
        sortNum: "",
        status: "",
        albums: [],
        cores: [{title:"",fileId:'',fileName:'',description:'',sortNum:''}],
        usages: [],
      },
      rules: {
        title: [{ required: true, message: "请输产品名称", trigger: "blur" }],

        productType: [
          { required: true, message: "请选择产品类型", trigger: "blur" },
        ],
        coverId: [{ required: true, message: "请上传封面", trigger: "blur" }],
        description: [{ required: true, message: "请添加描述", trigger: "blur" }],
        cores:[{ required: true, message: "请添加核心描述", trigger: "blur" }],
        appFileName: [
          { pattern: /^((ht|f)tps?):\/\/[\w-]+(\.[\w-]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?$/, message: "请输入正确的URL地址", trigger: "blur",},
        ],
        pcFileName: [
          { pattern: /^((ht|f)tps?):\/\/[\w-]+(\.[\w-]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?$/, message: "请输入正确的URL地址", trigger: "blur",},
        ],
      },

      async getpPoductType() {
        dataMap.productType = {};
        const menus = await getEnum("PRODUCT");
        for (const item of menus.data) {
          dataMap.productType[item.enumKey] = item;
        }
      },
      async getStatus() {
        dataMap.status = {};
        const menus = await getEnum("STATUS");
        for (const item of menus.data) {
          dataMap.status[item.enumKey] = item;
        }
      },
      async getUsageScene() {
        const res = await getAllUsage();
        for(const item of res.data){
          item.checked = false;
        }
          dataMap.usageScene = res?.data ?? [];
      },
      async getProduct() {
        const res = await getProductInfo(route.query.id);
        dataMap.ruleForm = res.data; 
        if (dataMap.ruleForm.coverName) dataMap.ruleForm.fileUrl =localStorage.getItem("fileUrel") + dataMap.ruleForm.coverName;
        if (dataMap.ruleForm.trialCoverName) dataMap.ruleForm.trialUrl =localStorage.getItem("fileUrel") + dataMap.ruleForm.trialCoverName;
        for(const item of dataMap.ruleForm.albums) {
          item.fileName = localStorage.getItem("fileUrel") +item.fileName;
        }
        for(const item of dataMap.ruleForm.cores) {
          if(item.fileName) item.fileName = localStorage.getItem("fileUrel") +item.fileName;
        }
        for(const item of dataMap.ruleForm.usages) {
          for(const list of dataMap.usageScene) {
            if(item.usageId === list.id) {
              list.checked = true;
            }
          }
        }
      },

      async putProduct() {
        let isEmpty = true;
        dataMap.ruleForm.usages =[];
        for(const item of dataMap.usageScene){
          if(item.checked){
            dataMap.ruleForm.usages.push({usageId:item.id});
            isEmpty = false;
          }
        }
        if(isEmpty) {
           ElMessage({ message: '请选择应用场景', type: "error",});
           return;
        }
        for(let i =0 ; i<  dataMap.ruleForm.cores.length; i++){
           dataMap.ruleForm.cores[i].sortNum = i+1;
        }
        for(let i =0 ; i<  dataMap.ruleForm.albums.length; i++){
           dataMap.ruleForm.albums[i].sortNum = i+1;
        }
        const res = await putProduct( dataMap.ruleForm);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          router.go(-1);
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
    });

    if (opt.row) {
      isEdit = true;
      dataMap.ruleForm = opt.row;
    }

    const onSuccess = (val: any) => {
      dataMap.ruleForm.coverId = val.id;
    };
    const onSamp = (val: any) => {
      dataMap.ruleForm.trialCoverId = val.id;
    };

    

    const coresSuccess = (val: any) => {
      dataMap.ruleForm.cores[dataMap.index].fileId = val.id;
    };
    const removeList = (index: any) => {
      dataMap.ruleForm.albums.splice(index, 1);
    };
    const addCores = () => {
      dataMap.ruleForm.cores.push({title:"",fileId:'',fileName:'',description:'',sortNum:''});
    };
    const removeCore = (index: any) => {
      dataMap.ruleForm.cores.splice(index, 1);
    };

    const getIndex = (index: any) => {
      dataMap.index = index;
    };

    const albumSuccess = (val: any) => {
      dataMap.ruleForm.albums.push({
        fileId: val.id,
        fileName: localStorage.getItem("fileUrel") + val.fileName,
        sortNum: 0,
      });
    };

    const drag = (e: any, index: any) => {
      dataMap.dragIndex = index;
      dataMap.temp = JSON.parse(JSON.stringify(dataMap.ruleForm.albums[index]));
    };
    const allowDrop = (e: any) => {
       e.preventDefault();  
    };

    const drop = (e: any, i: any) => {
      dataMap.dropIndex = i;
      dataMap.ruleForm.albums.splice(i + 1, 0, dataMap.temp);
      if (dataMap.dragIndex > dataMap.dropIndex) {  // 后往前拖
        dataMap.ruleForm.albums.splice(dataMap.dragIndex + 1, 1);
      } else {
        dataMap.ruleForm.albums.splice(dataMap.dragIndex, 1);
      }
     
    };

    
     const hdrag = (e: any, index: any) => {
      dataMap.dragIndex = index;
      dataMap.temp = JSON.parse(JSON.stringify(dataMap.ruleForm.cores[index]));
    };
    const hdrop = (e: any, i: any) => {
      dataMap.dropIndex = i;
      dataMap.ruleForm.cores.splice(i + 1, 0, dataMap.temp);
      if (dataMap.dragIndex > dataMap.dropIndex) {  // 后往前拖
        dataMap.ruleForm.cores.splice(dataMap.dragIndex + 1, 1);
      } else {
        dataMap.ruleForm.cores.splice(dataMap.dragIndex, 1);
      }
     
    };
    const submitForm = (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      formEl.validate((valid) => {
        if (valid) {
          dataMap.putProduct();
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };

    onMounted(() => {
      dataMap.getUsageScene();
      dataMap.getpPoductType();
      dataMap.getStatus();
      if (route.query.id) dataMap.getProduct();
    });

    return {
      show,
      store,
      isEdit,
      router,
      submitForm,
      close,
      route,
      onSuccess,
      addCores,
      removeList,
      albumSuccess,
      onSamp,
      drag,
      drop,
      hdrag,
      hdrop,
      allowDrop,
      coresSuccess,
      removeCore,
      getIndex,
      ...toRefs(dataMap),
    };
  },
});
